export default "__VITE_ASSET__BPProWzC__"